/* eslint-disable no-console */
/* eslint-disable unicorn/no-console-spaces */

/**
 * Get session is taken.
 *
 * @returns {any | undefined} Session is taken (original local storage).
 */
export const getSessionIsTaken = (): any | undefined => {
    const sessionIsTakenStringify = `${localStorage.getItem('sessionIsTaken')}`;

    let sessionIsTaken: any | undefined = undefined;
    try {
        sessionIsTaken = JSON.parse(sessionIsTakenStringify);
    } catch (error: any) {
        console.log('Get session is taken error: ', error.message);
    }

    return sessionIsTaken;
};
